import classNames from "classnames";
import styles from "./styles.module.scss";

interface InstructionProps {
  imgUrl: string;
  // eslint-disable-next-line
  htmlContent: any;
  children?: React.ReactNode;
  containerClassName?: string;
}

const Instruction = ({ 
  imgUrl,
  htmlContent,
  children,
  containerClassName = ""
}: InstructionProps) => {
  return (
    <div>
      <div className="m-divider-dashed-order mb-3"></div>
      {children && <div className="mb-3">{children}</div>}
      <div className={styles.paymentInstructionBox} data-testid="instruction">
        <div data-testid="instruction-image" className={classNames(styles.paymentMethodItemImage, containerClassName)}>
          <img src={imgUrl} alt="Logo" />
        </div>
        <span
          data-testid="instruction-text"
          className={styles.paymentInstructionText}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        ></span>
      </div>
    </div>
  );
};

export default Instruction;
